import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=167359c2&scoped=true"
import script from "./BlogPost.vue?vue&type=script&lang=js"
export * from "./BlogPost.vue?vue&type=script&lang=js"
import style0 from "./BlogPost.vue?vue&type=style&index=0&id=167359c2&prod&scoped=true&lang=css"
import style1 from "./BlogPost.vue?vue&type=style&index=1&id=167359c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167359c2",
  null
  
)

export default component.exports